import { Typography } from 'antd'

export const Link = Typography.Link
